import React, {useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import CS from "../../assets/CS 1.webp";
import real_time_accuracy from "../../assets/real_time_accuracy.webp";
import CS3 from "../../assets/CS 3.webp";
import frame from "../../assets/frame.webp";
import CS5 from "../../assets/CS 5.webp";
import cardImage1 from "../../assets/delivery.png";
import cardImage2 from "../../assets/timer.png";
import cardImage3 from "../../assets/tracking.png";
import cardImage4 from "../../assets/CS8.png";
import "./FiveCard.css";

const CodeStrength = () => {
  return (
    <section className="py-5 bg-white">
      <div className="container">
        <h2 className="text-center mb-5 fw-bold">Core Strengths</h2>

        <div className="row g-4">
          <div className="col-12 col-sm-6 col-lg-4">
            <div
              className="card border-0"
              style={{
                height: "350px",
                background: "linear-gradient(135deg, #F5FBFD, #D3EEFB)",
              }}
            >
              <div className="card-body d-flex flex-column h-100">
                <h3 className="card-title fw-bold fs-5 mb-3 mt-4 text-black">
                  Tailored for <br /> Businesses
                </h3>
                <div className="d-flex justify-content-center align-items-end flex-grow-1 mt-3">
                  <img
                    src={CS}
                    alt="Tailored for Restaurants"
                    className="img-fluid rounded"
                    style={{ maxHeight: "240px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-4">
            <div
              className="card border-0"
              style={{
                height: "350px",
                background: "linear-gradient(135deg, #FFF7ED, #FDE9D1)",
              }}
            >
              <div
                className="card-body d-flex flex-column"
                style={{ height: "100%" }}
              >
                <h3 className="card-title fw-bold fs-5 mb-3 mt-4 text-black">
                  Real-Time <br /> Accuracy
                </h3>

                <div className="mt-auto d-flex justify-content-center">
                  <img
                    src={real_time_accuracy}
                    alt="Real-Time Accuracy"
                    className="img-fluid rounded"
                    style={{ maxHeight: "260px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-4">
            <div
              className="card border-0"
              style={{
                height: " 350px",
                background: "linear-gradient(135deg, #E8FADD, #DCFFC6)",
              }}
            >
              <div className="card-body d-flex flex-column h-100">
                <h3 className="card-title fw-bold fs-5 mb-3 mt-4 text-black">
                  Enhanced Delivery <br /> Experience
                </h3>

                <div className="mt-auto d-flex justify-content-center">
                  <img
                    src={CS3}
                    alt="Enhanced Customer Experience"
                    className="img-fluid rounded"
                    style={{ maxHeight: "260px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-4">
            <div
              className="card border-0"
              style={{
                height: "350px",
                background: "linear-gradient(135deg, #FFF3ED, #FDDECF)",
                overflow: "hidden",
              }}
            >
              <div
                className="card-body d-flex flex-column"
                style={{ height: "100%" }}
              >
                <h3 className="card-title fw-bold fs-5 mb-3 mt-4 text-black">
                  Cost Efficiency
                </h3>

                <div
                  style={{
                    flex: "1 1 auto",
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "center",
                    marginTop: "-50px",
                  }}
                >
                  <img
                    src={frame}
                    alt="Cost Efficiency"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-12 col-lg-8">
            <div className="card card-custom">
              <div className="card-body d-flex flex-column">
                <h3 className="card-title fw-bold fs-5 mb-3 mt-4 text-black">
                  Real-Time Delivery <br /> Tracking
                </h3>

                <div className="d-flex justify-content-between align-items-start flex-wrap flex-sm-nowrap">
                  <div className="d-flex flex-wrap feature-wrapper mt-3 mb-3 px-3 gap-3">
                    {[cardImage1, cardImage2, cardImage3, cardImage4].map(
                      (img, index) => {
                        const texts = [
                          ["Easy", "Returns"],
                          ["Live-Order", "Tracking"],
                          ["Scheduled", "Deliveries"],
                          ["Contactless", "Delivery"],
                        ];
                        return (
                          <div key={index} className="feature-box">
                            <img src={img} alt={texts[index].join(" ")} />
                            <p className="feature-text">
                              {texts[index][0]} <br />
                              {texts[index][1]}
                            </p>
                          </div>
                        );
                      }
                    )}
                  </div>

                  <div className="tracking-img-wrapper d-flex justify-content-end align-items-end mt-4 mt-sm-0">
                    <img
                      src={CS5}
                      alt="Delivery tracking illustration"
                      className="img-fluid tracking-img"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CodeStrength;